import classNames from 'classnames';
import { handleImageError } from '@/utils/image-error';
import { getCdnUrl } from '@/utils/url';
import { CardImageWidth } from './constant';
import LazyImage from '../image/lazy-image';
interface Props {
  isLazy?: boolean;
  image: string;
  alt: string;
  srcSet: {
    mobile: number;
    desktop: number;
  };
  imageClassName: string;
  parentClassName?: string;
  width?: number;
  height?: number;
}
const DefaultProductCard = getCdnUrl('/_toad/images/default-product-card.png');
export const CardImage = ({
  isLazy = false,
  image,
  alt,
  srcSet,
  imageClassName,
  parentClassName = '',
  width,
  height
}: Props) => {
  const imageSrc = image ? `${image}?w=${CardImageWidth}` : DefaultProductCard;
  return <picture className={classNames(parentClassName, imageClassName, 'mx-auto')} data-sentry-element="picture" data-sentry-component="CardImage" data-sentry-source-file="card-image.tsx">
            {image && <>
                    <source media='(max-width: 768px)' srcSet={`${image}?w=${srcSet.mobile}`} />
                    <source media='(min-width: 769px)' srcSet={`${image}?w=${srcSet.desktop}`} />
                </>}

            {isLazy ? <LazyImage src={imageSrc} className={classNames('object-contain', imageClassName)} alt={alt} width={width} height={height} isLazy /> : <img src={imageSrc} className={classNames('object-contain', imageClassName)} alt={alt} onError={handleImageError} width={width} height={height} />}
        </picture>;
};